import AbstractResource from './AbstractResource';
import Directory from './Directory';
import { SerializedResource, Dimensions } from '@/types';

export default abstract class AbstractAsset extends AbstractResource {
  constructor(
    protected readonly resource: SerializedResource,
    protected parentDirectory: Directory
  ) {
    super(resource);
  }

  public isDirectory(): boolean {
    return false;
  }

  public isRoot(): boolean {
    return false;
  }

  public dimensions(): Dimensions | null {
    return this.info().dimensions || null;
  }

  public isRetina(): boolean {
    return this.dimensions()?.isRetina ?? false;
  }

  public width(): number | null {
    return this.info().dimensions?.width ?? null;
  }

  public height(): number | null {
    return this.info().dimensions?.height ?? null;
  }

  public parent(): Directory {
    return this.parentDirectory;
  }

  public directory(): Directory {
    return this.parent();
  }
}
